import { useState, useEffect, useCallback } from 'react';
import { AtendimentoService } from '../services/atendimentoService';
import { Atendimento } from '../types';

export const useMonitorData = (organizationId: string) => {
  const [currentPatient, setCurrentPatient] = useState<Atendimento | null>(null);
  const [lastCalled, setLastCalled] = useState<Atendimento[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadMonitorData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const [currentResponse, lastCalledResponse] = await Promise.all([
        AtendimentoService.getCurrentlyCalled(organizationId),
        AtendimentoService.getLastCalled(organizationId, 3)
      ]);

      if (currentResponse.success) {
        setCurrentPatient(currentResponse.data || null);
      } else {
        setError(currentResponse.message);
      }

      if (lastCalledResponse.success && lastCalledResponse.data) {
        setLastCalled(lastCalledResponse.data);
      }
    } catch (err) {
      setError('Erro ao carregar dados do monitor');
    } finally {
      setLoading(false);
    }
  }, [organizationId]);

  useEffect(() => {
    if (organizationId) {
      loadMonitorData();

      const subscription = AtendimentoService.subscribeToQueue(organizationId, () => {
        loadMonitorData();
      });

      const interval = setInterval(loadMonitorData, 5000);

      return () => {
        subscription.unsubscribe();
        clearInterval(interval);
      };
    }
  }, [organizationId, loadMonitorData]);

  return {
    currentPatient,
    lastCalled,
    loading,
    error,
    refetch: loadMonitorData
  };
};
